import type { CreateSynthesisSessionInput } from "../entities/synthesis-session"
import type { SynthesisSessionRepository } from "../repositories/synthesis-session-repository"

export const makeCreateSynthesisSession = (
  repo: SynthesisSessionRepository,
) => (input: CreateSynthesisSessionInput) => repo.create(input)
